import React from 'react'
import CmsCaptionImage from 'cms/CmsCaptionImage'
import SlickSlider from 'cms/components/slider/SlickSlider'

const CmsImageCarousel = ({
  images,
  settings,
  style,
  goto,
  defaultImage,
}) => {
  const filteredImages = images.filter((image) => image.active)
  return (
    <SlickSlider
      style={style}
      settings={settings}
      items={
        filteredImages.map(
          ({ link, source, target }, i) => {
            return (
              <div key={i}>
                <CmsCaptionImage
                  src={source}
                  link={link}
                  imageStyle={{ margin: '0 auto' }}
                  defaultImage={defaultImage}
                  {...link && { onClick: () => goto({ href: link, target }) }}
                />
              </div>
            )
          }
        )
      }
    />
  )
}

CmsImageCarousel.propTypes = {}
CmsImageCarousel.defaultProps = {}

export default CmsImageCarousel



// WEBPACK FOOTER //
// ./src/cms/CmsImageCarousel.js